import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/ui/design-system/components';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { buttonVariants } from '@/ui/design-system/components/ui/button';

export const SEND_TEST_CHOICE = {
    ALL: 'all',
    ME: 'me',
    CANCEL: 'cancel',
};

const SendTestConfirmModal = NiceModal.create(({ recipients = [] }) => {
    const modal = useModal();
    const recipientCount = recipients.length;
    const hasRecipients = recipientCount > 0;

    return (
        <AlertDialog
            open={modal.visible}
            onOpenChange={(open) => {
                if (!open) {
                    modal.hide();
                }
            }}
        >
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Send a test alert</AlertDialogTitle>
                    <AlertDialogDescription className="font-sans">
                        {hasRecipients
                            ? `This sends a live copy of the alert now to ${recipientCount} recipient${recipientCount === 1 ? '' : 's'}. You'll always get a copy.`
                            : 'This sends a live copy of the alert now to your email address.'}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel
                        onClick={() => modal.resolve(SEND_TEST_CHOICE.CANCEL)}
                    >
                        Cancel
                    </AlertDialogCancel>
                    <AlertDialogAction
                        onClick={() => modal.resolve(SEND_TEST_CHOICE.ME)}
                        className={
                            hasRecipients
                                ? buttonVariants({ variant: 'secondary' })
                                : undefined
                        }
                    >
                        Send to me only
                    </AlertDialogAction>
                    {hasRecipients && (
                        <AlertDialogAction
                            onClick={() => modal.resolve(SEND_TEST_CHOICE.ALL)}
                        >
                            Send to all
                        </AlertDialogAction>
                    )}
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
});

export default SendTestConfirmModal;
